import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { API_URL } from "../../utils/constant";
import Pagination from "../Pagination/Pagination";
import { toastr } from "react-redux-toastr";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { fetchUsers } from '../../actions/users';
import { fetchCustomerDomains } from '../../actions/customer';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";


const ActiveVaV2Issue = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    // State management for issues
    const [issues, setIssues] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedSeverity, setSelectedSeverity] = useState("");
    const [selectedAssignee, setSelectedAssignee] = useState("");
    const [domain, setDomain] = useState("");
    const [scannedAt, setScannedAt] = useState("");
    
    // Date picker states
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [tempStartDate, setTempStartDate] = useState(null);
    const [tempEndDate, setTempEndDate] = useState(null);
    const [startDateObj, setStartDateObj] = useState(null);
    const [endDateObj, setEndDateObj] = useState(null);
    
    const [severitySummary, setSeveritySummary] = useState({
        critical: 0,
        high: 0,
        medium: 0,
        low: 0,
        info: 0,
        none: 0
    });

    // States for snooze functionality
    const [selectedIds, setSelectedIds] = useState([]);
    const [multiCheckTrue, setMultiCheckTrue] = useState(false);
    const [isModal, setModal] = useState("");
    const [isModalTwo, setModalTwo] = useState("");
    const [selectedValue, setSelectedValue] = useState("pleaseSelect");
    const [name, setName] = useState("");
    const [lookalikeIssueId, setLookalikeIssueId] = useState([]);
    const [actionNote, setActionNote] = useState("");
    const [action, setAction] = useState("");
    const [forValue, setForValue] = useState("forever");
    const [category, setCategory] = useState("all");

    const [expandedRows, setExpandedRows] = useState(new Set());
    const [expandedRemedies, setExpandedRemedies] = useState(new Set());

    const toggleDescription = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };

    const toggleRemedy = (index) => {
        const newExpandedRemedies = new Set(expandedRemedies);
        if (newExpandedRemedies.has(index)) {
            newExpandedRemedies.delete(index);
        } else {
            newExpandedRemedies.add(index);
        }
        setExpandedRemedies(newExpandedRemedies);
    };


    // Mock assignees data
    const [assignees, setAssignees] = useState([]);

    // State for assignments
    const [assignments, setAssignments] = useState({});

    // Get organisation ID from Redux
    const id = useSelector(state => {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    });

    // Get user permissions
    const userPermission = useSelector(state => {
        return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
    });

    const users = useSelector((state) => state?.users?.response?.data || []);


    // Get user role
    const auth = useSelector((state) => state?.auth?.user);

    // Get customer domains
    const customerDomains = useSelector(
        (state) => state?.customer?.customerDomains?.data || []
    );

    // State for expanded cells (row id and column key)
    const [expandedCells, setExpandedCells] = useState({});
    const [technicalDetails, setTechnicalDetails] = useState(null);
    const [showTechnicalModal, setShowTechnicalModal] = useState(false);

    // Add a ref to track if we've set severity from URL
    const didSetSeverityFromUrl = useRef(false);

    // Add state for Jira ticket creation loading
    const [creatingTicket, setCreatingTicket] = useState({});

    // Add state for severity totals from API
    const [severityTotals, setSeverityTotals] = useState({
        critical: 0,
        high: 0,
        medium: 0,
        low: 0,
        info: 0,
        none: 0
    });
    const [severityTotalsLoading, setSeverityTotalsLoading] = useState(false);

    // Add function to fetch severity totals
    const fetchSeverityTotals = async () => {
        try {
            setSeverityTotalsLoading(true);
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

            // Add query parameters
            let queryParams = '';
            if (startDate && endDate) queryParams += `?scannedAt=${startDate} to ${endDate}`;
            else if (startDate) queryParams += `?scannedAt=${startDate}`;
            else if (endDate) queryParams += `?scannedAt=${endDate}`;

            const response = await axios.get(`${API_URL}/active-scan/${id}/severity-totals${queryParams}`);

            if (response.data && response.data.data) {
                setSeverityTotals({
                    critical: response.data.data.critical || 0,
                    high: response.data.data.high || 0,
                    medium: response.data.data.medium || 0,
                    low: response.data.data.low || 0,
                    info: response.data.data.info || 0,
                    none: response.data.data.none || 0
                });
            }
        } catch (error) {
            // console.error removed
            // Fallback to existing summary if API fails
        } finally {
            setSeverityTotalsLoading(false);
        }
    };

    // On mount, set severity from URL if present
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const severityParam = searchParams.get('severity');
        if (severityParam && !didSetSeverityFromUrl.current) {
            setSelectedSeverity(severityParam);
            didSetSeverityFromUrl.current = true;
        }
    }, [location.search]);

    useEffect(() => {
        if (users.length > 0) {
            setAssignees(users)
        }
    }, [users])

    useEffect(() => {
        if (id) {
            fetchUsers(id, dispatch);
            fetchSeverityTotals(); // Fetch severity totals when componentmounts
            // Fetch domains for the current client/organization
        }
    }, [id]);

    useEffect(() => {
        // Fetch domains for the current client/organization
        if (id) {
            dispatch(fetchCustomerDomains(id));
        }
    }, [id, dispatch]);

    // Update startDateObj and endDateObj whenever startDate or endDate change
    useEffect(() => {
        if (startDate) {
            setStartDateObj(new Date(startDate));
        }
        if (endDate) {
            setEndDateObj(new Date(endDate));
        }
    }, [startDate, endDate]);

    // Update tempStartDate and tempEndDate whenever startDate or endDate change
    useEffect(() => {
        if (startDate) {
            setTempStartDate(new Date(startDate));
        }
        if (endDate) {
            setTempEndDate(new Date(endDate));
        }
    }, [startDate, endDate]);

    // Only fetch issues when all filters are ready and not during initial URL sync
    useEffect(() => {
        if (id) {
            fetchIssues();
            // Refresh severity totals when filters change
            if (page === 1) { // Only refresh totals on first page to avoid excessive API calls
                fetchSeverityTotals();
            }
        }
    }, [id, page, limit, selectedSeverity, searchQuery, category, selectedAssignee, domain, startDate, endDate]);

    // Helper to toggle expanded state
    const toggleCell = (issueId, col) => {
        setExpandedCells(prev => {
            const newState = { ...prev };
            // Toggle only the specific cell
            newState[`${issueId}-${col}`] = !newState[`${issueId}-${col}`];
            return newState;
        });
    };



    // Fetch active scan issues
    const fetchIssues = async () => {
        try {
            setIssues([]);
            setLoading(true);
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

            // Add query parameters
            let queryParams = `?page=${page}&limit=${limit}`;
            if (searchQuery) queryParams += `&search=${encodeURIComponent(searchQuery)}`;
            if (selectedSeverity) queryParams += `&severity=${selectedSeverity}`;
            if (category) queryParams += `&category=${category}`;
            if (selectedAssignee) queryParams += `&assignees=${selectedAssignee}`;
            if (domain) queryParams += `&domain=${domain}`;
            if (startDate && endDate) queryParams += `&scannedAt=${startDate} to ${endDate}`;
            else if (startDate) queryParams += `&scannedAt=${startDate}`;
            else if (endDate) queryParams += `&scannedAt=${endDate}`;

            const response = await axios.get(`${API_URL}/active-scan/${id}${queryParams}`);

            if (response.data.data.data) {
                setIssues(response.data.data.data);
                setTotalItems(response.data.data.totalCount || 0);

                // Fallback: If severity totals API fails, use summary from main API
                if (severityTotalsLoading && response.data.data.summary) {
                    setSeverityTotals({
                        critical: response.data.data.summary?.critical || 0,
                        high: response.data.data.summary?.high || 0,
                        medium: response.data.data.summary?.medium || 0,
                        low: response.data.data.summary?.low || 0,
                        info: response.data.data.summary?.info || 0,
                        none: response.data.data.summary?.none || 0
                    });
                }
            }
            setLoading(false);
        } catch (error) {
            // console.error removed
            toastr.error("Error", "Failed to fetch active scan issues");
            setLoading(false);
        }
    };

    const handleVulnerabilityAction = async (scanIds, actionType, note = "", duration = "forever", isUnsnooze = false) => {
        try {
            setLoading(true);
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

            const endpoint = isUnsnooze
                ? `${API_URL}/active-scan/${id}/ActiveVulnsAndNuclie/action`
                : `${API_URL}/active-scan/${id}/ActiveVulnsAndNuclie/action`;

            const data = {
                action: isUnsnooze ? "resetAction" : actionType,
                [isUnsnooze ? "recordIds" : "recordIds"]: scanIds,
                actionNote: note,
                for: duration
            };

            const response = await axios.post(endpoint, data);

            toastr.success(
                response.data.message || "Success",
                isUnsnooze ? "Items have been unsnoozed" : "Action applied successfully"
            );

            fetchIssues();
            fetchSeverityTotals(); // Refresh severity totals after action
            setSelectedIds([]);
        } catch (error) {
            // console.error removed
            toastr.error("Error", isUnsnooze ? "Failed to unsnooze items" : "Failed to apply action");
            setLoading(false);
        }
    };

    // Replace the old functions with references to the new one
    const handleSnoozeAction = (scanIds, actionType, note = "", duration = "forever") =>
        handleVulnerabilityAction(scanIds, actionType, note, duration, false);

    const unsnooze = (ids) =>
        handleVulnerabilityAction(ids, "resetAction", "", "forever", true);

    // Handle multi-selection check
    const multicheck = (data) => {
        const allIds = data?.map((item) => item?._id || item?.scanId || item?._id);
        if (selectedIds.length > 0 || selectedIds.length === 0) {
            setMultiCheckTrue(true);
            setSelectedIds(allIds);
        }
        if (multiCheckTrue === true) {
            setSelectedIds([]);
            setMultiCheckTrue(false);
        }
    };

    // Handle single item selection
    const singleClick = (id) => {
        setSelectedIds((prevSelectedIds) => {
            if (prevSelectedIds.includes(id)) {
                return prevSelectedIds.filter((selectedId) => selectedId !== id);
            } else {
                return [...prevSelectedIds, id];
            }
        });
    };

    // Handle snooze button click
    const snooze = (_id, event, name) => {
        if (event === "markAsRemidiated") {
            handleSnoozeAction(selectedIds.length === 0 ? [_id] : selectedIds, "markAsRemidiated");
            setSelectedValue("pleaseSelect");
            setActionNote("");
            setSelectedIds([]);
        } else if (event === "riskAccepted" || event === "markAsFalsePositive") {
            setAction(event);
            setModalTwo("Form Wizard modal two");
            if (_id) {
                setLookalikeIssueId([_id]);
                setName(name);
            }
        }
    };

    // Submit snooze with comments
    const submitSnooze = () => {
        handleSnoozeAction(
            selectedIds.length === 0 ? lookalikeIssueId : selectedIds,
            action,
            actionNote,
            forValue
        );
        setModalTwo("");
        setSelectedValue("pleaseSelect");
        setActionNote("");
        setSelectedIds([]);
    };

    // Get appropriate badge color based on severity
    const getSeverityBadgeClass = (severity) => {
        switch (severity?.toLowerCase()) {
            case 'critical':
                return 'badge-danger';
            case 'high':
                return 'badge-warning';
            case 'medium':
                return 'badge-primary';
            case 'low':
                return 'badge-info';
            default:
                return 'badge-secondary';
        }
    };


    const downloadFile = async () => {
        try {
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
            const response = await axios.get(
                `${API_URL}/active-scan/${id}/excel`,
                {
                    responseType: "blob",
                }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Active Vulnerabilities.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            // console.error removed
        }
    };

    // Handle assignment change
    const handleAssignmentChange = (issueId, selectedValues) => {
        // Create a completely new assignments object
        setAssignments(prev => {
            const newAssignments = {};
            // Copy all existing assignments
            Object.keys(prev).forEach(key => {
                newAssignments[key] = [...(prev[key] || [])];
            });
            // Update only the specific issue's assignments
            newAssignments[issueId] = [...selectedValues];
            return newAssignments;
        });
    };

    // Handle bulk assignment
    const handleBulkAssignment = (assigneeId) => {
        if (selectedIds.length === 0) return;

        setAssignments(prev => {
            const newAssignments = {};
            // Copy all existing assignments
            Object.keys(prev).forEach(key => {
                newAssignments[key] = [...(prev[key] || [])];
            });
            // Update only selected issues
            selectedIds.forEach(issueId => {
                const currentAssignments = newAssignments[issueId] || [];
                if (!currentAssignments.includes(assigneeId)) {
                    newAssignments[issueId] = [...currentAssignments, assigneeId];
                }
            });
            return newAssignments;
        });
    };

    // Get assignee names for display
    const getAssigneeNames = (assigneeIds) => {
        if (!assigneeIds || assigneeIds.length === 0) return 'Unassigned';
        return assigneeIds.map(id => {
            const assignee = assignees.find(a => a.id === id);
            return assignee ? assignee.name : '';
        }).join(', ');
    };

    // Filter issues based on selected assignee
    const filteredIssues = issues.filter(issue => {
        if (!selectedAssignee || selectedAssignee === "none") return true;
        const issueAssignments = Array.isArray(issue?.assignedTo) ? issue?.assignedTo : [];
        return issueAssignments.includes(selectedAssignee);
    });

    // Update function to handle severity card click
    const handleSeverityClick = (severity) => {
        const newSeverity = selectedSeverity === severity ? '' : severity;

        // Update state first
        setSelectedSeverity(newSeverity);
        setPage(1);

        // Then update URL
        const searchParams = new URLSearchParams(location.search);
        if (newSeverity) {
            searchParams.set('severity', newSeverity);
        } else {
            searchParams.delete('severity');
        }
        history.replace(`${location.pathname}?${searchParams.toString()}`);
    };

    // Add this function to get initials from name
    const getInitials = (name) => {
        if (!name) return '';
        return name.split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    // Add this function near other API calls
    const handleAssignIssue = async (issueId, assigneeIds, collection) => {
        try {
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

            const response = await axios.post(`${API_URL}/active-scan/${id}/assign-issue`, {
                issueId: issueId,
                collection: collection,
                assignees: Array.isArray(assigneeIds) ? assigneeIds : [assigneeIds] // Ensure it's always an array
            });

            if (!response.data.error) {
                toastr.success('Success', response.data.userMessage);
                fetchIssues();
                fetchSeverityTotals(); // Refresh severity totals after assignment
            } else {
                toastr.error('Error', response.data.userMessage);
            }
        } catch (error) {
            // console.error removed
            toastr.error('Error', 'Failed to assign issue');
        }
    };

    // Add function to create Jira ticket
    const createJiraTicket = async (issueId) => {
        try {
            setCreatingTicket(prev => ({ ...prev, [issueId]: true }));
            const session = localStorage.getItem("session");
            const response = await axios.post(
                `${API_URL}/active-scan/${id}/create-jira-ticket`,
                {
                    vulnerabilityIds: [issueId]
                },
                {
                    headers: {
                        'Authorization': `Bearer ${session}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data) {
                toastr.success('Success', 'Jira ticket created successfully');
                // Refresh the issues list to show the new ticket
                fetchIssues();
                fetchSeverityTotals(); // Refresh severity totals after Jira ticket creation
            }
        } catch (error) {
            // console.error removed
            toastr.error('Error', 'Failed to create Jira ticket');
        } finally {
            setCreatingTicket(prev => ({ ...prev, [issueId]: false }));
        }
    };

    // Add this new function to format the displayed date range
    const formatDateRange = () => {
        if (startDate && endDate) {
            return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
        } else if (startDate) {
            return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
        } else if (endDate) {
            return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
        }
        return "Select date range"; // Default placeholder text
    };

    // Add this function to handle applying the selected date range
    const applyDateRange = () => {
        if (tempStartDate) {
            setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
        } else {
            setStartDate('');
        }

        if (tempEndDate) {
            setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
        } else {
            setEndDate('');
        }

        setDatePickerOpen(false);
        setPage(1);
    };

    // Update the cancelDateSelection function to clear all dates
    const cancelDateSelection = () => {
        // Clear all date states when cancel is clicked
        setTempStartDate(null);
        setTempEndDate(null);
        setStartDate('');
        setEndDate('');
        setStartDateObj(null);
        setEndDateObj(null);
        setDatePickerOpen(false);
    };

    return (
        <div className="container-fluid">
            <style>
                {`
                    .stat-card {
                        transition: all 0.3s ease;
                        border: 1px solid #e0e0e0;
                        border-radius: 8px;
                        padding: 15px;
                        margin: 5px;
                        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    }
                    .stat-card:hover {
                        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                        transform: translateY(-2px);
                    }
                    .stat-card.active {
                        border: 2px solid #2196f3;
                        background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
                    }
                    .stat-card.active .text-muted {
                        color: #1976d2 !important;
                    }
                    .stat-card.active .font-weight-bold {
                        color: #1976d2;
                    }
                    .vulnerability-flags .badge {
                        margin-bottom: 2px;
                        display: block;
                        width: fit-content;
                        font-weight: 500;
                    }
                    .vulnerability-scores {
                        line-height: 1.3;
                    }
                    .vulnerability-references a {
                        display: block;
                        margin-bottom: 2px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 100px;
                    }
                    .vulnerability-references a:hover {
                        text-decoration: underline !important;
                    }
                    .expandable-section {
                        cursor: pointer;
                        color: #1976d2;
                        font-size: 11px;
                    }
                    .expandable-section:hover {
                        text-decoration: underline;
                    }
                    .table-custom {
                        border-radius: 8px;
                        overflow: hidden;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .table-custom thead th {
                        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                        border-bottom: 2px solid #dee2e6;
                        font-weight: 600;
                        color: #495057;
                        padding: 12px 8px;
                        font-size: 13px;
                    }
                    .table-custom tbody tr {
                        transition: all 0.2s ease;
                    }
                    .table-custom tbody tr:hover {
                        background-color: #f8f9fa;
                        transform: scale(1.001);
                    }
                    .table-custom tbody td {
                        padding: 12px 8px;
                        border-bottom: 1px solid #f1f3f4;
                        vertical-align: top;
                    }
                    .vulnerability-name {
                        font-weight: 600;
                        color: #2c3e50;
                        line-height: 1.4;
                    }
                    .vulnerability-host {
                        color: #1976d2;
                        font-weight: 500;
                        font-size: 12px;
                    }
                    .vulnerability-cve {
                        font-family: 'Courier New', monospace;
                        font-weight: 600;
                        color: #e74c3c;
                        background-color: #fdf2f2;
                        padding: 2px 6px;
                        border-radius: 4px;
                        font-size: 11px;
                    }
                    .severity-badge {
                        font-weight: 600;
                        padding: 4px 8px;
                        border-radius: 6px;
                        font-size: 11px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .description-container {
                        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                        border: 1px solid #e9ecef;
                        border-radius: 6px;
                        padding: 8px;
                        margin: 4px 0;
                    }
                    .description-text {
                        color: #495057;
                        line-height: 1.5;
                        font-size: 12px;
                    }
                    .score-container {
                        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                        border: 1px solid #e9ecef;
                        border-radius: 6px;
                        padding: 6px;
                        margin: 2px 0;
                    }
                    .score-label {
                        font-weight: 600;
                        font-size: 10px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .cvss-score {
                        color: #1976d2;
                    }
                    .epss-score {
                        color: #ff9800;
                    }
                    .flag-badge {
                        font-weight: 600;
                        padding: 2px 6px;
                        border-radius: 4px;
                        font-size: 9px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        margin: 1px 0;
                    }
                    .reference-link {
                        color: #1976d2;
                        text-decoration: none;
                        font-size: 10px;
                        padding: 2px 4px;
                        border-radius: 3px;
                        transition: all 0.2s ease;
                    }
                    .reference-link:hover {
                        background-color: #e3f2fd;
                        text-decoration: none;
                    }
                    .date-cell {
                        font-size: 11px;
                        color: #6c757d;
                        font-weight: 500;
                    }
                    .jira-button {
                        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
                        border: none;
                        color: white;
                        padding: 4px 8px;
                        border-radius: 4px;
                        font-size: 10px;
                        font-weight: 600;
                        transition: all 0.2s ease;
                    }
                    .jira-button:hover {
                        background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
                        transform: translateY(-1px);
                    }
                    .jira-button:disabled {
                        background: #6c757d;
                        cursor: not-allowed;
                    }
                    .width25 {
                        width: 18%;
                        min-width: 120px;
                    }
                    @media (max-width: 1200px) {
                        .width25 {
                            width: 19%;
                            min-width: 100px;
                        }
                    }
                    .remediation-cell {
                        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                        border-left: 3px solid #28a745;
                    }
                    .description-cell {
                        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                        border-left: 3px solid #007bff;
                    }
                    .table-custom tbody td {
                        padding: 12px 8px;
                        border-bottom: 1px solid #f1f3f4;
                        vertical-align: top;
                        position: relative;
                    }
                    .table-custom tbody tr:hover .remediation-cell,
                    .table-custom tbody tr:hover .description-cell {
                        background: linear-gradient(135deg, #e3f2fd 0%, #f8f9fa 100%);
                        transform: scale(1.01);
                        transition: all 0.2s ease;
                    }
                    .technical-data-container {
                        transition: all 0.2s ease;
                    }
                    .technical-data-container:hover {
                        background: linear-gradient(135deg, #e3f2fd 0%, #f8f9fa 100%) !important;
                        transform: scale(1.02);
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .technical-data-container .monospace-text {
                        font-family: 'Courier New', monospace;
                        background-color: #f8f9fa;
                        border: 1px solid #e9ecef;
                        border-radius: 4px;
                        padding: 4px;
                        font-size: 9px;
                        max-height: 60px;
                        overflow: auto;
                    }
                    .technical-data-container a {
                        transition: all 0.2s ease;
                    }
                    .technical-data-container a:hover {
                        color: #0d47a1 !important;
                        text-decoration: underline !important;
                        background-color: #e3f2fd;
                        padding: 1px 2px;
                        border-radius: 2px;
                    }

                    /* Date picker styles */
                    .date-picker-container {
                        position: relative;
                        width: 100%;
                    }
                    .date-range-input {
                        position: relative;
                        cursor: pointer;
                    }
                    .date-range-input input {
                        cursor: pointer;
                        padding-right: 30px;
                    }
                    .calendar-icon {
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                        pointer-events: none;
                        color: #6c757d;
                    }
                    .date-range-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 1050;
                    }
                    .date-range-picker-popup {
                        background: white;
                        border-radius: 8px;
                        padding: 20px;
                        max-width: 600px;
                        width: 90%;
                        max-height: 90vh;
                        overflow-y: auto;
                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
                    }
                    .date-range-picker-header {
                        text-align: center;
                        font-weight: bold;
                        margin-bottom: 20px;
                        color: #333;
                    }
                    .date-range-calendars {
                        display: flex;
                        gap: 20px;
                        justify-content: center;
                        flex-wrap: wrap;
                    }
                    .date-range-calendars h6 {
                        text-align: center;
                        margin-bottom: 10px;
                        color: #333;
                    }
                    .date-range-actions {
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 20px;
                    }
                    .date-range-apply {
                        background-color: #007bff;
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .date-range-apply:hover {
                        background-color: #0056b3;
                    }
                    .date-range-cancel {
                        background-color: #6c757d;
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .date-range-cancel:hover {
                        background-color: #545b62;
                    }

                `}
            </style>
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Active Vulnerability Issues</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/" className="welcome-textSmall">Home</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                                    Vulnerability Issues
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
                        {issues?.length === 0 ? null : (
                            <>
                                <a
                                    href="/consolidated-assets"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-primary mr-1 h45"
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                >
                                    <i className="fa fa-folder-open" style={{ fontSize: '14px' }}></i>
                                    Assets
                                </a>
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadFile();
                                    }}
                                    href="/add-report"
                                    className="btn btn-sm btn-primary mr-1 download-report"
                                >
                                    Download Details
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className="card card_tableBox">
                <div className="body">
                    <div className="row mb-2">
                        <div className="col-md-12">
                            {/* {!selectedSeverity ? ( */}
                            <div className="d-flex flex-wrap align-items-between w-100">
                                {[
                                    { severity: 'critical', label: 'Critical' },
                                    { severity: 'high', label: 'High' },
                                    { severity: 'medium', label: 'Medium' },
                                    { severity: 'low', label: 'Low' }
                                ].map(({ severity, label }) => (
                                    <div
                                        key={severity}
                                        className={`stat-card width25 ${selectedSeverity === severity ? 'active' : ''}`}
                                        onClick={() => handleSeverityClick(severity)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div>
                                            <span className="d-block h4 mb-0 font-weight-bold">
                                                {severityTotalsLoading ? (
                                                    <i className="fa fa-spinner fa-spin" style={{ fontSize: '14px' }}></i>
                                                ) : (
                                                    severityTotals[severity]
                                                )}
                                            </span>
                                            <span className="text-muted">{label}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/* ) : null} */}
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12">
                            <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                                <li className="nav-item">
                                    <a
                                        className={`nav-table-tab nav-link ${category === "all" ? "active" : ""}`}
                                        onClick={() => {
                                            setCategory("all");
                                            setPage(1);
                                            setSelectedIds([]);
                                            // Reset date filter
                                            setStartDate('');
                                            setEndDate('');
                                            setTempStartDate(null);
                                            setTempEndDate(null);
                                            setStartDateObj(null);
                                            setEndDateObj(null);
                                        }}
                                    >
                                        Current
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""}`}
                                        onClick={() => {
                                            setCategory("risk-accepted");
                                            setPage(1);
                                            setSelectedIds([]);
                                            // Reset date filter
                                            setStartDate('');
                                            setEndDate('');
                                            setTempStartDate(null);
                                            setTempEndDate(null);
                                            setStartDateObj(null);
                                            setEndDateObj(null);
                                        }}
                                    >
                                        Risk Accepted
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""}`}
                                        onClick={() => {
                                            setCategory("false-positive");
                                            setPage(1);
                                            setSelectedIds([]);
                                            // Reset date filter
                                            setStartDate('');
                                            setEndDate('');
                                            setTempStartDate(null);
                                            setTempEndDate(null);
                                            setStartDateObj(null);
                                            setEndDateObj(null);
                                        }}
                                    >
                                        False Positive
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""}`}
                                        onClick={() => {
                                            setCategory("remidiated");
                                            setPage(1);
                                            setSelectedIds([]);
                                            // Reset date filter
                                            setStartDate('');
                                            setEndDate('');
                                            setTempStartDate(null);
                                            setTempEndDate(null);
                                            setStartDateObj(null);
                                            setEndDateObj(null);
                                        }}
                                    >
                                        Remediated
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-3">
                            <select
                                className="form-control form-control-sm"
                                value={selectedSeverity}
                                onChange={(e) => {
                                    setSelectedSeverity(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <option value="">All Severities</option>
                                <option value="critical">Critical</option>
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                                <option value="info">Info</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <select
                                className="form-control form-control-sm"
                                value={selectedAssignee}
                                onChange={(e) => {
                                    const value = e.target.value === "none" ? "" : e.target.value;
                                    setSelectedAssignee(value);
                                    setPage(1);
                                }}
                            >
                                <option value="none">All Assignees</option>
                                {assignees.map(assignee => (
                                    <option key={assignee?._id} value={assignee?._id}>
                                        {assignee?.fullName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <input
                                type="text"
                                className="form-control form-control-sm mb-2"
                                placeholder="Search CVE, host, description..."
                                value={searchQuery}
                                onChange={(e) => {
                                    setSearchQuery(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            <select
                                className="form-control form-control-sm"
                                value={domain}
                                onChange={(e) => {
                                    setDomain(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <option value="">All Domains</option>
                                {customerDomains?.domains?.map((domainItem, index) => (
                                    <option key={index} value={domainItem}>
                                        {domainItem}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <div className="date-picker-container">
                                <div className="date-range-input">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Select date range"
                                        value={formatDateRange()}
                                        onClick={() => setDatePickerOpen(true)}
                                        readOnly
                                    />
                                    <span className="calendar-icon">
                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9"></div>
                    </div>

                    <div className="row mb-3">
                        {/* Snooze Actions for Multiple Selection */}
                        <div className="col-md-3 text-right">
                            {selectedIds?.length > 1 && userPermission && category === "all" && (
                                <Box sx={{ width: 160, display: 'inline-block' }}>
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="snooze-select-label"
                                            id="snooze-select"
                                            value={selectedValue}
                                            onChange={(event) => {
                                                setAction(event.target.value);
                                                snooze("", event.target.value);
                                            }}
                                        >
                                            <MenuItem value="pleaseSelect">
                                                Snooze Options
                                            </MenuItem>
                                            <MenuItem value="riskAccepted">
                                                Risk Accepted
                                            </MenuItem>
                                            <MenuItem value="markAsFalsePositive">
                                                False Positive
                                            </MenuItem>
                                            <MenuItem value="markAsRemidiated">
                                                Remediated
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            )}
                            {selectedIds?.length > 1 && (category === "false-positive" || category === "risk-accepted") && userPermission && (
                                <button
                                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                    onClick={() => unsnooze(selectedIds)}
                                >
                                    Unsnooze
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="table-responsive" style={{ overflowX: 'auto', width: '100%' }}>
                        <table className="table table-custom spacing5 mb-0" style={{ minWidth: 1400 }}>
                            <thead>
                                <tr>
                                    {userPermission && (category === "all" || category === "false-positive" || category === "risk-accepted") && (
                                        <th style={{ width: 40 }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.length > 0 && multiCheckTrue}
                                                onChange={() => multicheck(issues)}
                                                className="checkUncheck"
                                            />
                                        </th>
                                    )}
                                    <th style={{ width: 200, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Name</th>
                                    <th style={{ width: 150 }}>Severity & Details</th>
                                    <th style={{ width: 150, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Host/Target</th>
                                    <th style={{ width: 300 }}>Description</th>
                                    <th style={{ width: 150 }}>Technical Data</th>
                                    <th style={{ width: 500 }}>Remediation</th>
                                    <th style={{ width: 90 }}>Created At</th>
                                    <th style={{ width: 90 }}>Scanned At</th>
                                    {category !== "all" && <th style={{ width: 120 }}>Action Note</th>}
                                   
                                    {userPermission && (category === "all" || category === "risk-accepted" || category === "false-positive") && (
                                        <th style={{ width: 120 }}>Action</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredIssues?.map((issue, index) => (
                                    <tr key={index}>
                                        {userPermission && (category === "all" || category === "false-positive" || category === "risk-accepted") && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds?.includes(issue?._id)}
                                                    onChange={() => singleClick(issue?._id)}
                                                    className="checkUncheck"
                                                />
                                            </td>
                                        )}
                                        {/* Name: always show full, allow wrapping */}
                                        <td style={{ whiteSpace: 'normal' }}>
                                            <div className="vulnerability-name">
                                                {issue?.name || 'Unknown'}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                {/* Severity Badge */}
                                                <span className={`badge  ${getSeverityBadgeClass(issue.severity)}`}>
                                                    {issue.severity || 'Unknown'}
                                                </span>

                                                {/* CVE ID */}
                                                {issue?.cveId && (
                                                    <div style={{ fontSize: '10px', marginTop: '2px' }}>
                                                        <span style={{ fontWeight: '600', color: '#e74c3c' }}>CVE:</span>
                                                        <span className="vulnerability-cve" style={{ fontSize: '9px', marginLeft: '4px' }}>
                                                            {issue.cveId}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* CVSS/EPSS Scores */}
                                                {(issue?.cvss_score || issue?.epss) && (
                                                    <div style={{ fontSize: '10px', marginTop: '2px' }}>
                                                        {(issue?.cvss_score && issue?.cvss_score.length !== 0) && (
                                                            <div style={{ marginBottom: '2px' }}>
                                                                <span style={{ fontWeight: '600', color: '#1976d2' }}>CVSS:</span>
                                                                <span style={{ fontWeight: '600', color: '#1976d2', fontSize: '9px' }}> {issue?.cvss_score}/10</span>
                                                            </div>
                                                        )}
                                                        {(issue?.epss && issue?.epss.length !== 0) && (
                                                            <div>
                                                                <span style={{ fontWeight: '600', color: '#ff9800' }}>EPSS:</span>
                                                                <span style={{ fontWeight: '600', color: '#ff9800', fontSize: '9px' }}> {(issue?.epss * 100).toFixed(2)}%</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Boolean Flags */}
                                                {(issue?.is_poc || issue?.is_remote || issue?.is_oss || issue?.is_exploited || issue?.hasExploits) && (
                                                    <div style={{ fontSize: '9px', marginTop: '4px' }}>
                                                        {issue?.is_poc === true && (
                                                            <span className="badge badge-warning flag-badge" style={{ marginRight: '2px', marginBottom: '2px' }}>
                                                                PoC
                                                            </span>
                                                        )}
                                                        {issue?.is_remote === true && (
                                                            <span className="badge badge-danger flag-badge" style={{ marginRight: '2px', marginBottom: '2px' }}>
                                                                Remote
                                                            </span>
                                                        )}
                                                        {issue?.is_oss === true && (
                                                            <span className="badge badge-info flag-badge" style={{ marginRight: '2px', marginBottom: '2px' }}>
                                                                OSS
                                                            </span>
                                                        )}
                                                        {issue?.is_exploited === true && (
                                                            <span className="badge badge-dark flag-badge" style={{ marginRight: '2px', marginBottom: '2px' }}>
                                                                Exploited
                                                            </span>
                                                        )}
                                                        {issue?.hasExploits === true && (
                                                            <span className="badge badge-warning flag-badge" style={{ marginRight: '2px', marginBottom: '2px' }}>
                                                                Exploits
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        {/* Host/Target: show more/less */}
                                        <td style={{ maxWidth: 190, whiteSpace: expandedCells[`${issue?._id}-host`] ? 'normal' : 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                            <span title={issue?.host || issue?.target || 'N/A'}>
                                                {expandedCells[`${issue?._id}-host`] ? (
                                                    <Link to={`/consolidated-assets/${issue.host || issue.target || 'N/A'}`} className="vulnerability-host">
                                                        {issue.host || issue.target || 'N/A'}
                                                    </Link>
                                                ) : (
                                                    <Link to={`/consolidated-assets/${issue.host || issue.target || 'N/A'}`} className="vulnerability-host">
                                                        {(issue?.host || issue?.target || 'N/A')?.toString().slice(0, 40)}
                                                    </Link>
                                                )}
                                                {((issue.host || issue.target || 'N/A')?.toString().length > 40) && (
                                                    <>
                                                        {!expandedCells[`${issue?._id}-host`] ? <span style={{ color: '#1976d2', cursor: 'pointer', fontSize: '10px' }} onClick={() => toggleCell(issue?._id, 'host')}>... Show more</span> : <span style={{ color: '#1976d2', cursor: 'pointer', fontSize: '10px' }} onClick={() => toggleCell(issue?._id, 'host')}> Show less</span>}
                                                    </>
                                                )}
                                            </span>
                                        </td>



                                        {/* Description: show more/less */}
                                        <td className="description-cell" style={{
                                            width: "300px",
                                            wordWrap: "break-word",
                                            lineHeight: "1.5",
                                            padding: "12px 16px",
                                            verticalAlign: "top"
                                        }}>
                                            {issue?.description ? (
                                                <div style={{
                                                    backgroundColor: expandedRows.has(index) ? '#f8f9fa' : 'transparent',
                                                    padding: expandedRows.has(index) ? '12px' : '8px',
                                                    borderRadius: expandedRows.has(index) ? '8px' : '6px',
                                                    border: expandedRows.has(index) ? '1px solid #e9ecef' : '1px solid #f0f0f0',
                                                    transition: 'all 0.3s ease',
                                                    width: '100%',
                                                    overflow: 'hidden',
                                                    minHeight: '60px'
                                                }}>
                                                    <div style={{
                                                        fontSize: '13px',
                                                        color: '#2c3e50',
                                                        marginBottom: expandedRows.has(index) ? '8px' : '0',
                                                        wordWrap: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        fontWeight: '500',
                                                        whiteSpace: expandedRows.has(index) ? 'pre-wrap' : 'normal',
                                                        ...(expandedRows.has(index) ? {
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            lineHeight: '1.6'
                                                        } : {
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 4,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            lineHeight: '1.4',
                                                            maxHeight: 'calc(1.4em * 4)'
                                                        })
                                                    }}>
                                                        {issue?.description}
                                                    </div>
                                                    <span
                                                        className="text-primary"
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            textDecoration: 'none',
                                                            padding: '3px 6px',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#e3f2fd',
                                                            color: '#1976d2',
                                                            transition: 'all 0.2s ease',
                                                            display: 'inline-block',
                                                            marginTop: '4px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#bbdefb';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#e3f2fd';
                                                        }}
                                                        onClick={() => toggleDescription(index)}
                                                    >
                                                        {expandedRows.has(index) ? 'Show less' : 'Show more'}
                                                    </span>
                                                </div>
                                            ) : (
                                                <span style={{
                                                    color: '#6c757d',
                                                    fontStyle: 'italic',
                                                    fontSize: '13px',
                                                    padding: '8px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '4px',
                                                    display: 'block'
                                                }}>
                                                    No description available
                                                </span>
                                            )}
                                        </td>
                                        {/* Technical Data Column */}
                                        <td>
                                            <div className="technical-data-container" style={{
                                                backgroundColor: '#f8f9fa',
                                                border: '1px solid #e9ecef',
                                                borderRadius: '6px',
                                                padding: '8px',
                                                fontSize: '11px'
                                            }}>
                                                {/* Show Details Button */}
                                                {(issue?.request || issue?.response || issue?.vulnerabilities?.synopsis ||
                                                    issue?.vulnerabilities?.solution || issue?.vulnerabilities?.seeAlso) && (
                                                        <div style={{ textAlign: 'center' }}>
                                                            <button
                                                                className="btn btn-sm btn-outline-info"
                                                                style={{ fontSize: '10px', padding: '3px 6px' }}
                                                                onClick={() => {
                                                                    setTechnicalDetails({
                                                                        issue: issue,
                                                                        cvssScore: issue?.vulnerabilities?.cvssV2?.baseScore,
                                                                        port: issue?.vulnerabilities?.port,
                                                                        protocol: issue?.vulnerabilities?.protocol,
                                                                        pluginId: issue?.vulnerabilities?.pluginId,
                                                                        scanCounter: issue?.vulnerabilities?.scanCounter,
                                                                        pluginOutput: issue?.vulnerabilities?.pluginOutput,
                                                                        request: issue?.request,
                                                                        response: issue?.response,
                                                                        synopsis: issue?.vulnerabilities?.synopsis,
                                                                        solution: issue?.vulnerabilities?.solution,
                                                                        seeAlso: issue?.vulnerabilities?.seeAlso,
                                                                        target: issue?.target,
                                                                        name: issue?.name
                                                                    });
                                                                    setShowTechnicalModal(true);
                                                                }}
                                                            >
                                                                <i className="fas fa-cogs me-1" style={{ fontSize: '9px' }}></i>
                                                                Show Details
                                                            </button>
                                                        </div>
                                                    )}
                                            </div>
                                        </td>
                                        {/* Remediation: show more/less */}
                                        <td className="remediation-cell" style={{
                                            width: "500px",
                                            wordWrap: "break-word",
                                            lineHeight: "1.5",
                                            padding: "12px 16px",
                                            verticalAlign: "top"
                                        }}>
                                            {issue?.remedy ? (
                                                <div style={{
                                                    backgroundColor: expandedRemedies.has(index) ? '#f8f9fa' : 'transparent',
                                                    padding: expandedRemedies.has(index) ? '12px' : '8px',
                                                    borderRadius: expandedRemedies.has(index) ? '8px' : '6px',
                                                    border: expandedRemedies.has(index) ? '1px solid #e9ecef' : '1px solid #f0f0f0',
                                                    transition: 'all 0.3s ease',
                                                    width: '100%',
                                                    overflow: 'hidden',
                                                    minHeight: '60px'
                                                }}>
                                                    <div style={{
                                                        fontSize: '13px',
                                                        color: '#2c3e50',
                                                        marginBottom: expandedRemedies.has(index) ? '8px' : '0',
                                                        wordWrap: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        fontWeight: '500',
                                                        whiteSpace: expandedRemedies.has(index) ? 'pre-wrap' : 'normal',
                                                        ...(expandedRemedies.has(index) ? {
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            lineHeight: '1.6'
                                                        } : {
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 4,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            lineHeight: '1.4',
                                                            maxHeight: 'calc(1.4em * 4)'
                                                        })
                                                    }}>
                                                        {issue?.remedy}
                                                    </div>
                                                    <span
                                                        className="text-primary"
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            textDecoration: 'none',
                                                            padding: '3px 6px',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#e3f2fd',
                                                            color: '#1976d2',
                                                            transition: 'all 0.2s ease',
                                                            display: 'inline-block',
                                                            marginTop: '4px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#bbdefb';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#e3f2fd';
                                                        }}
                                                        onClick={() => toggleRemedy(index)}
                                                    >
                                                        {expandedRemedies.has(index) ? 'Show less' : 'Show more'}
                                                    </span>
                                                </div>
                                            ) : (
                                                <span style={{
                                                    color: '#6c757d',
                                                    fontStyle: 'italic',
                                                    fontSize: '13px',
                                                    padding: '8px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '4px',
                                                    display: 'block'
                                                }}>
                                                    No remediation available
                                                </span>
                                            )}
                                        </td>
                                        <td className="date-cell">{issue?.createdAt ? moment(issue?.createdAt).format("DD-MM-YYYY") : issue?.vulnerabilities?.createdAt ? moment(issue?.vulnerabilities?.createdAt).format("DD-MM-YYYY") : "N/A"}</td>

                                        <td className="date-cell">{issue?.updatedAt? moment(issue?.updatedAt).format("DD-MM-YYYY") : moment(issue?.scannedAt).format("DD-MM-YYYY")}</td>
                                        {category !== "all" && <td style={{ whiteSpace: "unset" }}>{issue?.actionNote ? issue.actionNote : "N/A"}</td>}
                                        {/* <td>
                                            {!issue?.jiraIssueKey ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <button
                                                        className="jira-button"
                                                        onClick={() => createJiraTicket(issue._id)}
                                                        disabled={creatingTicket[issue._id]}
                                                    >
                                                        {creatingTicket[issue._id] ? (
                                                            <>
                                                                <i className="fa fa-spinner fa-spin"></i>
                                                                Creating...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="fa fa-plus"></i>
                                                                Create Ticket
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            ) : (
                                                <span style={{ fontSize: '11px', fontFamily: 'monospace', fontWeight: '600', color: '#1976d2' }}>
                                                    {issue.jiraIssueKey}
                                                </span>
                                            )}
                                        </td> */}
                                        {/* <td>
                                            <Box sx={{ width: 200 }}>
                                                <FormControl fullWidth size="small">
                                                    <Select
                                                        multiple
                                                        value={Array.isArray(issue?.assignedTo) ? issue?.assignedTo : []}
                                                        onChange={(e) => {
                                                            const selectedIds = e.target.value;
                                                            handleAssignIssue(issue?._id, selectedIds, issue?.source);
                                                        }}
                                                        displayEmpty
                                                        renderValue={(selected) => {
                                                            if (!selected || !Array.isArray(selected) || selected.length === 0) {
                                                                return <em>Unassigned</em>;
                                                            }

                                                            return (
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    gap: '4px'
                                                                }}>
                                                                    {selected.map((assigneeId) => {
                                                                        const selectedUser = users?.find(user => user?._id === assigneeId);
                                                                        if (!selectedUser) return null;

                                                                        return (
                                                                            <div key={assigneeId} style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '4px',
                                                                                backgroundColor: '#e3f2fd',
                                                                                padding: '2px 6px',
                                                                                borderRadius: '12px',
                                                                                fontSize: '12px'
                                                                            }}>
                                                                                <span style={{
                                                                                    backgroundColor: '#2196f3',
                                                                                    color: 'white',
                                                                                    width: '20px',
                                                                                    height: '20px',
                                                                                    borderRadius: '50%',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontSize: '10px'
                                                                                }}>
                                                                                    {getInitials(selectedUser?.fullName)}
                                                                                </span>
                                                                                {selectedUser?.fullName}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            );
                                                        }}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 300
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {users?.map((user) => (
                                                            <MenuItem
                                                                key={user?._id}
                                                                value={user?._id}
                                                                selected={Array.isArray(issue?.assignedTo) && issue?.assignedTo?.includes(user?._id)}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span style={{
                                                                        backgroundColor: '#2196f3',
                                                                        color: 'white',
                                                                        width: '24px',
                                                                        height: '24px',
                                                                        borderRadius: '50%',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '12px'
                                                                    }}>
                                                                        {getInitials(user?.fullName)}
                                                                    </span>
                                                                    {user?.fullName || 'Unknown User'}
                                                                </div>
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </td> */}

                                        {userPermission && (
                                            <>
                                                {category === "all" && (
                                                    <td>
                                                        <Box sx={{ width: 160 }}>
                                                            <FormControl fullWidth>
                                                                <Select
                                                                    labelId="single-snooze-select-label"
                                                                    id="single-snooze-select"
                                                                    value={selectedValue}
                                                                    onChange={(event) => {
                                                                        setAction(event.target.value);
                                                                        snooze(
                                                                            issue?._id,
                                                                            event.target.value,
                                                                            issue?.name
                                                                        );
                                                                    }}
                                                                >
                                                                    <MenuItem value="pleaseSelect">
                                                                        Snooze Options
                                                                    </MenuItem>
                                                                    <MenuItem value="riskAccepted">
                                                                        Risk Accepted
                                                                    </MenuItem>
                                                                    <MenuItem value="markAsFalsePositive">
                                                                        False Positive
                                                                    </MenuItem>
                                                                    <MenuItem value="markAsRemidiated">
                                                                        Remediated
                                                                    </MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                    </td>
                                                )}
                                                {(category === "risk-accepted" || category === "false-positive") && (
                                                    <td>
                                                        <button
                                                            className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                                            onClick={() => unsnooze([issue?._id])}
                                                        >
                                                            Unsnooze
                                                        </button>
                                                    </td>
                                                )}
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-between align-content-center mt-3">
                        <div className="dataTables_paginate">
                            {totalItems > 0 && (
                                <Pagination
                                    className="pagination-bar"
                                    currentPage={page}
                                    totalCount={totalItems}
                                    pageSize={limit}
                                    onPageChange={(page) => setPage(page)}
                                />
                            )}
                        </div>
                        {totalItems > 10 && (
                            <select
                                value={limit}
                                onChange={(e) => {
                                    setLimit(e.target.value);
                                    setPage(1);
                                }}
                                className="form-control limitSelectBox"
                            >
                                <option value={10}>10 per page</option>
                                <option value={25}>25 per page</option>
                                <option value={50}>50 per page</option>
                                <option value={100}>100 per page</option>
                            </select>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal for Snooze Action Details */}
            <div
                className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""}`}
            >
                <div className="modal-dialog modal-lg" id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {action === "markAsFalsePositive"
                                    ? "Mark As False Positive"
                                    : "Risk Accepted"}
                            </h5>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    setModalTwo("");
                                    setActionNote("");
                                }}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page modal_mob">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="card">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <label className="col-lg-6 col-md-12">Snooze for</label>
                                            <div className="form-group col-lg-12 col-md-12">
                                                <select
                                                    className="custom-select custom-select-sm form-control form-control-sm"
                                                    onChange={(e) => setForValue(e.target.value)}
                                                >
                                                    <option value="forever">Forever</option>
                                                    <option value="3 months">3 Months</option>
                                                    <option value="6 months">6 Months</option>
                                                    <option value="12 months">12 Months</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <label className="col-lg-12 col-md-12">Detail</label>
                                            <div className="form-group col-lg-12 col-md-12">
                                                <textarea
                                                    onChange={(e) => setActionNote(e.target.value)}
                                                    value={actionNote}
                                                    className="form-control"
                                                    rows="3"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-lg-12 col-md-12"
                                            style={{ marginRight: "28px" }}
                                        >
                                            <button
                                                type="button"
                                                style={{ color: "black", fontWeight: "bold" }}
                                                onClick={submitSnooze}
                                                className="btn btn-round btn-primary mr-1 pull-right"
                                            >
                                                Submit
                                            </button>
                                            &nbsp;&nbsp;
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setModalTwo("");
                                                    setActionNote("");
                                                }}
                                                className="btn btn-round btn-default pull-right"
                                                style={{ marginRight: "10px" }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Technical Details Modal */}
            {showTechnicalModal && technicalDetails && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-cogs me-2"></i>
                                    Technical Details - {technicalDetails.name}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowTechnicalModal(false);
                                        setTechnicalDetails(null);
                                    }}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div className="row">
                                    {/* Basic Information */}
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <h6 className="mb-0">
                                                    <i className="fas fa-info-circle me-2"></i>
                                                    Basic Information
                                                </h6>
                                            </div>
                                            <div className="card-body">
                                                <table className="table table-sm">
                                                    <tbody>
                                                        {technicalDetails.cvssScore && (
                                                            <tr>
                                                                <td><strong>CVSS Score:</strong></td>
                                                                <td>
                                                                    <span className="badge badge-danger">
                                                                        {technicalDetails.cvssScore}/10
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                        {technicalDetails.port && (
                                                            <tr>
                                                                <td><strong>Port:</strong></td>
                                                                <td>
                                                                    {technicalDetails.port}
                                                                    {technicalDetails.protocol && (
                                                                        <span className="text-muted">/{technicalDetails.protocol.toUpperCase()}</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )}
                                                        {technicalDetails.pluginId && (
                                                            <tr>
                                                                <td><strong>Plugin ID:</strong></td>
                                                                <td>{technicalDetails.pluginId}</td>
                                                            </tr>
                                                        )}
                                                        {technicalDetails.scanCounter && (
                                                            <tr>
                                                                <td><strong>Scan Counter:</strong></td>
                                                                <td>{technicalDetails.scanCounter}</td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td><strong>Target:</strong></td>
                                                            <td>{technicalDetails.target}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Technical Details */}
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <h6 className="mb-0">
                                                    <i className="fas fa-code me-2"></i>
                                                    Technical Details
                                                </h6>
                                            </div>
                                            <div className="card-body">
                                                {technicalDetails.synopsis && (
                                                    <div className="mb-3">
                                                        <h6 className="text-primary">Synopsis</h6>
                                                        <div className="bg-light p-2 rounded" style={{ fontSize: '13px' }}>
                                                            {technicalDetails.synopsis.length > 700 ? (
                                                                <div>
                                                                    <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                        {technicalDetails.synopsis.substring(0, 700)}...
                                                                    </div>
                                                                    <div className="text-center mt-2">
                                                                        <button
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            onClick={() => {
                                                                                const blob = new Blob([technicalDetails.synopsis], { type: 'text/plain' });
                                                                                const url = URL.createObjectURL(blob);
                                                                                const a = document.createElement('a');
                                                                                a.href = url;
                                                                                a.download = `synopsis_${technicalDetails.issue._id}.txt`;
                                                                                document.body.appendChild(a);
                                                                                a.click();
                                                                                document.body.removeChild(a);
                                                                                URL.revokeObjectURL(url);
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-download me-1"></i>
                                                                            Download Full Synopsis
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                    {technicalDetails.synopsis}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {technicalDetails.solution && (
                                                    <div className="mb-3">
                                                        <h6 className="text-success">Solution</h6>
                                                        <div className="bg-light p-2 rounded" style={{ fontSize: '13px' }}>
                                                            {technicalDetails.solution.length > 700 ? (
                                                                <div>
                                                                    <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                        {technicalDetails.solution.substring(0, 700)}...
                                                                    </div>
                                                                    <div className="text-center mt-2">
                                                                        <button
                                                                            className="btn btn-sm btn-outline-success"
                                                                            onClick={() => {
                                                                                const blob = new Blob([technicalDetails.solution], { type: 'text/plain' });
                                                                                const url = URL.createObjectURL(blob);
                                                                                const a = document.createElement('a');
                                                                                a.href = url;
                                                                                a.download = `solution_${technicalDetails.issue._id}.txt`;
                                                                                document.body.appendChild(a);
                                                                                a.click();
                                                                                document.body.removeChild(a);
                                                                                URL.revokeObjectURL(url);
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-download me-1"></i>
                                                                            Download Full Solution
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                    {technicalDetails.solution}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Plugin Output */}
                                                {technicalDetails.pluginOutput && (
                                                    <div className="mb-3">
                                                        <h6 className="text-info">
                                                            <i className="fas fa-terminal me-1"></i>
                                                            Plugin Output
                                                        </h6>
                                                        <div className="bg-light p-2 rounded" style={{ fontSize: '13px' }}>
                                                            {technicalDetails.pluginOutput.length > 700 ? (
                                                                <div>
                                                                    <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                        {technicalDetails.pluginOutput.substring(0, 700)}...
                                                                    </div>
                                                                    <div className="text-center mt-2">
                                                                        <button
                                                                            className="btn btn-sm btn-outline-info"
                                                                            onClick={() => {
                                                                                const blob = new Blob([technicalDetails.pluginOutput], { type: 'text/plain' });
                                                                                const url = URL.createObjectURL(blob);
                                                                                const a = document.createElement('a');
                                                                                a.href = url;
                                                                                a.download = `plugin_output_${technicalDetails.issue._id}.txt`;
                                                                                document.body.appendChild(a);
                                                                                a.click();
                                                                                document.body.removeChild(a);
                                                                                URL.revokeObjectURL(url);
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-download me-1"></i>
                                                                            Download Full Plugin Output
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                    {technicalDetails.pluginOutput}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Request/Response Section */}
                                {(technicalDetails.request || technicalDetails.response) && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h6 className="mb-0">
                                                        <i className="fas fa-exchange-alt me-2"></i>
                                                        Request/Response Data
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        {technicalDetails.request && (
                                                            <div className="col-md-6">
                                                                <h6 className="text-info">Request</h6>
                                                                <div className="bg-dark text-light p-3 rounded" style={{
                                                                    fontSize: '11px',
                                                                    maxHeight: '300px',
                                                                    overflow: 'auto'
                                                                }}>
                                                                    {technicalDetails.request.length > 700 ? (
                                                                        <div>
                                                                            <pre style={{ fontSize: '10px', color: '#ffffff' }}>
                                                                                {technicalDetails.request.substring(0, 700)}...
                                                                            </pre>
                                                                            <div className="text-center mt-2">
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-info"
                                                                                    onClick={() => {
                                                                                        const blob = new Blob([technicalDetails.request], { type: 'text/plain' });
                                                                                        const url = URL.createObjectURL(blob);
                                                                                        const a = document.createElement('a');
                                                                                        a.href = url;
                                                                                        a.download = `request_${technicalDetails.issue._id}.txt`;
                                                                                        document.body.appendChild(a);
                                                                                        a.click();
                                                                                        document.body.removeChild(a);
                                                                                        URL.revokeObjectURL(url);
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-download me-1"></i>
                                                                                    Download Full Request
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <pre style={{ fontSize: '10px', color: '#ffffff' }}>
                                                                            {technicalDetails.request}
                                                                        </pre>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {technicalDetails.response && (
                                                            <div className="col-md-6">
                                                                <h6 className="text-warning">Response</h6>
                                                                <div className="bg-dark text-light p-3 rounded" style={{
                                                                    fontSize: '11px',
                                                                    maxHeight: '300px',
                                                                    overflow: 'auto'
                                                                }}>
                                                                    {technicalDetails.response.length > 700 ? (
                                                                        <div>
                                                                            <pre style={{ fontSize: '10px', color: '#ffffff' }}>
                                                                                {technicalDetails.response.substring(0, 700)}...
                                                                            </pre>
                                                                            <div className="text-center mt-2">
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-warning"
                                                                                    onClick={() => {
                                                                                        const blob = new Blob([technicalDetails.response], { type: 'text/plain' });
                                                                                        const url = URL.createObjectURL(blob);
                                                                                        const a = document.createElement('a');
                                                                                        a.href = url;
                                                                                        a.download = `response_${technicalDetails.issue._id}.txt`;
                                                                                        document.body.appendChild(a);
                                                                                        a.click();
                                                                                        document.body.removeChild(a);
                                                                                        URL.revokeObjectURL(url);
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-download me-1"></i>
                                                                                    Download Full Response
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <pre style={{ fontSize: '10px', color: '#ffffff' }}>
                                                                            {technicalDetails.response}
                                                                        </pre>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* See Also Links */}
                                {technicalDetails.seeAlso && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h6 className="mb-0">
                                                        <i className="fas fa-external-link-alt me-2"></i>
                                                        See Also Links
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        {technicalDetails.seeAlso.split('\n').map((link, idx) => (
                                                            <div key={idx} className="col-md-6 mb-2">
                                                                <a
                                                                    href={link.trim()}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-outline-primary btn-sm"
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <i className="fas fa-external-link-alt me-1"></i>
                                                                    {link.trim().length > 50 ?
                                                                        `${link.trim().substring(0, 50)}...` :
                                                                        link.trim()
                                                                    }
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowTechnicalModal(false);
                                        setTechnicalDetails(null);
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Date picker modal */}
            {datePickerOpen && (
                <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
                    <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
                        <div className="date-range-picker-header">
                            {tempStartDate && tempEndDate
                                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                                : "Select date range"}
                        </div>
                        <div className="date-range-calendars">
                            <div>
                                <h6>From</h6>
                                <DatePicker
                                    selected={tempStartDate}
                                    onChange={(date) => {
                                        setTempStartDate(date);
                                        if (tempEndDate && date > tempEndDate) {
                                            setTempEndDate(null);
                                        }
                                    }}
                                    selectsStart
                                    startDate={tempStartDate}
                                    endDate={tempEndDate}
                                    inline
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                            <div>
                                <h6>To</h6>
                                <DatePicker
                                    selected={tempEndDate}
                                    onChange={(date) => setTempEndDate(date)}
                                    selectsEnd
                                    startDate={tempStartDate}
                                    endDate={tempEndDate}
                                    minDate={tempStartDate}
                                    inline
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                        </div>
                        <div className="date-range-actions">
                            <button
                                className="date-range-apply"
                                onClick={applyDateRange}
                            >
                                Apply Filter
                            </button>
                            <button
                                className="date-range-cancel"
                                onClick={cancelDateSelection}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActiveVaV2Issue;
